import React from "react";
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import VideoRecorderComponent from "../../VideoRecorderComponent";

function CandidateOverviewAboutText({onEdit,data}) {
  return (
    <div className="container_sections_wrapper">
      <div className="candidate-about__r5-about-text"  > 
      <div>
        <h3 style={{fontWeight:700,fontSize:'17px'}}>About</h3>

          <p style={{marginLeft:'6px'}}>{data?.aboutUser}</p>
          </div>
         {data?.videoUrl && <div style={{flex:1,display:'flex',marginTop:5,marginLeft:20,alignItems:'flex-start',justifyContent:'flex-start'}}> 

    <VideoRecorderComponent onSelectVideo={()=>{}} incomingVideoUrl={data?.videoUrl}/>
    </div>
}
      </div>
      <div style={data?.videoUrl ?{marginTop:'-26%'}:{}} onClick={onEdit} className="edit_icon"><ModeEditOutlineOutlinedIcon style={{height:'20px',width:'20px'}}/> </div>

    </div>
  );
}

export default CandidateOverviewAboutText;
